import React from 'react';

import { Box } from '@mui/material';
import { DateTime } from 'luxon';

import { DateFormatPatterns } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';

import { ButtonDatePicker } from 'src/components/common';
import { useDashboardCVAdminData } from 'src/hooks/dashboard';

import { MIN_DATE, NOW } from '../constants';

import { DASHBOARD_FILTER_CV_ADMIN_POPOVER_ANCHOR_GAP } from './constants';
import {
  DASHBOARD_FILTER_CV_ADMIN_BUTTON_END_ICON_STYLES,
  DASHBOARD_FILTER_CV_ADMIN_BUTTON_STYLES,
} from './styles';

export const DashboardFilterCVAdminDateButton: React.FC<{
  getAnchorRef: () => Nullable<HTMLElement>;
  disabled?: boolean;
}> = ({ getAnchorRef, disabled }) => {
  const { date: contextDate, setDate: setContextDate } = useDashboardCVAdminData();
  const [date, setDate] = React.useState(contextDate);

  const handleSetDate = React.useCallback(
    (date: Nullable<DateTime>) => {
      if (!date?.isValid) return;
      const isoDate = date.endOf('day');
      setContextDate(isoDate);
      setDate(date);
    },
    [setContextDate],
  );

  React.useEffect(() => {
    setDate(contextDate);
  }, [contextDate]);

  const anchorEl = getAnchorRef() || undefined;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box display="inline-block" fontWeight="bold">
        Snapshot as of:
      </Box>
      <ButtonDatePicker
        disabled={disabled}
        views={['year', 'month', 'day']}
        timezone="UTC"
        minDate={MIN_DATE}
        maxDate={NOW}
        value={date}
        onChange={handleSetDate}
        buttonProps={{
          style: DASHBOARD_FILTER_CV_ADMIN_BUTTON_STYLES,
          sx: DASHBOARD_FILTER_CV_ADMIN_BUTTON_END_ICON_STYLES,
        }}
        format={DateFormatPatterns.fullMonthDayYear}
        slotProps={{
          popper: {
            anchorEl,
            placement: 'bottom-start',
            sx: { pt: DASHBOARD_FILTER_CV_ADMIN_POPOVER_ANCHOR_GAP },
          },
        }}
      />
    </Box>
  );
};
